import { useEffect, useRef } from 'react';

import { getRequest } from '@/api/api.ts';
import { PREFETCH_ENDPOINTS } from '@/config/prefetchEndpoints.ts';
import type { NormalizedSessionUser } from '@/store/auth/auth.dto.ts';

export const usePrefetchEndpoints = (session: NormalizedSessionUser | null) => {
  const prefetched = useRef(false);

  useEffect(() => {
    if (!session || prefetched.current || !PREFETCH_ENDPOINTS.length) return;
    prefetched.current = true;

    void Promise.allSettled(
      PREFETCH_ENDPOINTS.map(({ api, url, params }) =>
        getRequest(api, url, false, params as Record<string, any>),
      ),
    );
  }, [session]);
};
